import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryMetricsComponent } from './tractors-history-metrics.component';
import {DxLoadPanelModule, DxScrollViewModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsHistoryMetricsComponent],
  imports: [
    CommonModule,
    DxLoadPanelModule,
    DxScrollViewModule
  ],
  exports: [TractorsHistoryMetricsComponent]
})
export class TractorsHistoryMetricsModule { }
